export default {
  
  'purchasingGrouping.form.company': 'Company',
  'purchasingGrouping.form.supplier': 'Supplier',
  'purchasingGrouping.form.documentType': 'Document Type',

  'purchasingGrouping.form.table.purchasesToBeGrouped': 'Purchases to be Grouped',
  'purchasingGrouping.form.table.code': 'Code',
  'purchasingGrouping.form.table.documentNumber': 'Document Number',
  'purchasingGrouping.form.table.issuanceDate': 'Issuance Date',
  'purchasingGrouping.form.table.releaseDateOf': 'Release Date Of',
  'purchasingGrouping.form.table.departureDate': 'Departure Date',
  'purchasingGrouping.form.table.amount': 'Amount',


  'purchasingGrouping.form.button.generateCluster': 'Generate Cluster',
  'purchasingGrouping.form.button.searchForPurchases': 'Search For Purchases',

};
